import { Input, Component, OnInit } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  @Input() fontSize: string = '1rem';

  constructor() { }

  ngOnInit() {
  }

}
